import { parse } from 'date-fns';
import { format } from 'date-fns';
import { removeOrdinalSuffix } from 'utils/shared/date/removeOrdinalSuffix';

export const datesToDateRange = (startDateString: string, endDateString: string): string => {
  const formattedStartDateString = removeOrdinalSuffix(startDateString);
  const formattedEndDateString = removeOrdinalSuffix(endDateString);

  const startDate = parse(formattedStartDateString, 'MMMM d, yyyy', new Date());
  const endDate = parse(formattedEndDateString, 'MMMM d, yyyy', new Date());

  const formattedStartDate = format(startDate, "MMMM d'th'");
  const formattedEndDate = format(endDate, "MMMM d'th', yyyy");

  return `${formattedStartDate} - ${formattedEndDate}`;
};

export const formatDateRange = (startDate: string, endDate: string): string => {
  const yearOptions: Intl.DateTimeFormatOptions = { year: 'numeric' };
  const monthDayOptions: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };

  const startMonthDay = new Intl.DateTimeFormat('en-US', monthDayOptions).format(
    new Date(startDate),
  );
  const endMonthDay = new Intl.DateTimeFormat('en-US', monthDayOptions).format(new Date(endDate));
  const year = new Intl.DateTimeFormat('en-US', yearOptions).format(new Date(endDate));

  return `${startMonthDay} - ${endMonthDay}, ${year}`;
};
